import React, { Component, Fragment } from "react";
import CheckAuth from "../../../utils/hoc/CheckAuth";
import Button from "../../../components/atoms/Button";
import DataTable from "../../organism/DataTable";
import ReactDOM from "react-dom";
import Loan from "../../../redux/actions/Loan";
import Loading from "../../../components/molecules/Loading";
import { connect } from "react-redux";
import curencyFormat from "../../../utils/helpers/curencyFormat";
import dateFormatIndo from "../../../utils/helpers/dateFormatIndo";
import formatNumber from "../../../utils/helpers/formatNumber";

let Aktif = [
	{ title: "Kode Pinjaman", data: "loanCode", width: "140" },
	{ title: "Jatuh Tempo", data: "loanDueDate", width: "100" },
	{ title: "Tenor", data: "loanDuration", width: "40" },
	{ title: "Nilai Pinjaman", data: "loanAmount", width: "100" },
	{ title: "Status", data: "loanProgress", width: "120" },
	{ title: "Progres", data: "loanProgress", width: "50" },
	{ title: "Suku Bunga", data: "loanRate", width: "100" },
	{ title: "Tipe Pinjaman", data: "nameProductMapping", width: "100" },
	{ title: "", data: "loanCode", width: "100" },
];
let statusLoanAkt = ["PB0", "IN1", "WD0", "DS1", "WD1", "AGR", "SGN"];

class PinjamanAktif extends Component {
	constructor(props) {
		super(props);
		this.state = {
			coloumnDefsAktif: [
				{
					targets: 1,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>{cellData ? dateFormatIndo(cellData, "short") : "-"}</span>, td);
					},
				},
				{
					targets: 2,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>{cellData || "-"} hari</span>, td);
					},
				},
				{
					targets: 3,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>Rp {curencyFormat(cellData)}</span>, td);
					},
				},
				{
					targets: 5,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>{formatNumber((rowData.investedAmount / rowData.loanAmount) * 100, "", 2)}%</span>, td);
					},
				},
				{
					targets: 6,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>{cellData ? formatNumber(cellData, "", 2) : "-"}% p.a.</span>, td);
					},
				},
				{
					targets: Aktif.length - 1,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<Button title={"Lihat"} onClick={() => this.gotoDetail(cellData)} type={"button"} color="blue" width="small" />, td);
					},
				},
			],
			idTable: "aktif",
			statusLoan: statusLoanAkt,
		};
	}
	componentDidMount = () => {
		console.log("masuk pinjaman aktif");

		this.props.setTitlePage({
			title: "Pinjaman Aktif",
			breadcrumb: [
				{ name: "Beranda", url: "/dashboard", status: false },
				{ name: "Pinjaman Aktif", url: "/#", status: true },
			],
		});
		if (this.props.ClientID !== null) {
			this.props.getListLoan(this.props.ClientID, this.state.statusLoan);
		}
	};
	gotoDetail = (loancode) => {
		this.props.history.push(`pinjaman-aktif/detil/${loancode}`);
	};
	render() {
		let { data, coloumnDataTable, statusBtn, coloumnDefsAktif, coloumnDefsSelesai, coloumnDefsGagal, idTable } = this.state;
		const { list, loading } = this.props.loan;
		return (
			<div>
				{loading ? (
					<Loading />
				) : (
					<Fragment>
						<DataTable
							isDisplay={idTable === "aktif" ? true : false}
							idTable={"aktif"}
							data={list != null ? list.filter((list) => statusLoanAkt.includes(list.loanStatus)) : ""}
							coloumn={Aktif}
							coloumnDefs={coloumnDefsAktif}
							fixedWidthColoumn={true}
						/>
					</Fragment>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		loan: state.loanState,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getListLoan: (ClientID, status) => {
			dispatch(Loan(ClientID, status));
		},
	};
};
export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(PinjamanAktif));
